import { useMobileSelect } from "./useMobileSelect";
import { SelectProps } from "../Select";
import { ArrowIcon } from "components/common/Icons/ArrowIcon";
import { MobileOptions } from "../MobileOptions/MobileOptions";

export interface MobileSelectProps<T>
    extends Pick<
        SelectProps<T>,
        | "options"
        | "defaultValue"
        | "handleClick"
        | "value"
        | "getOptionLabel"
        | "getOptionValue"
        | "label"
        | "labelClassNames"
        | "mobileStyles"
    > {
    testKey: string;
}

export const MobileSelect = <T,>({
    options,
    defaultValue,
    handleClick,
    value,
    getOptionLabel,
    getOptionValue,
    label,
    labelClassNames,
    testKey,
    mobileStyles,
}: MobileSelectProps<T>) => {
    const { isFocused, toggleFocus, ref, selected, handleOptionClick, handleClose } = useMobileSelect(
        defaultValue ?? options[0] ?? null,
        handleClick,
        value,
    );

    return (
        <>
            <div className="lg:hidden">
                <div
                    className={`relative flex items-center cursor-pointer w-full bg-white dark:bg-darkSurface-200 rounded-lg hover:bg-irGray-200 ${
                        isFocused && "bg-irGray-200"
                    } border-irGray-400 dark:border-darkSurface-100 border px-4 py-3 gap-2`}
                    style={{
                        ...(mobileStyles?.control ?? {}),
                    }}
                    onClick={toggleFocus}
                    ref={ref}
                >
                    <div>{!selected ? "" : getOptionLabel ? getOptionLabel(selected) : getOptionValue(selected)}</div>
                    <div className="ml-auto pointer-events-none">
                        {isFocused ? (
                            <div className="rotate-180">
                                <ArrowIcon stroke={mobileStyles?.dropdownIndicator?.color || undefined} />
                            </div>
                        ) : (
                            <ArrowIcon stroke={mobileStyles?.dropdownIndicator?.color} />
                        )}
                    </div>
                </div>
            </div>

            {isFocused && (
                <div className="lg:hidden">
                    <MobileOptions
                        isFocused={isFocused}
                        options={options}
                        selected={selected}
                        getOptionLabel={getOptionLabel}
                        getOptionValue={getOptionValue}
                        handleOptionClick={handleOptionClick}
                        handleClose={handleClose}
                        label={label}
                        labelClassNames={labelClassNames}
                        testKey={testKey}
                    />
                </div>
            )}
        </>
    );
};
